<template>
  <div class="customer-flow page-container">
    <QueryContainer v-model="searchLoading" @search="handleSearch" @reset="handleReset">
      <template v-slot:searchContent>
        <StatisticsSearchForm v-model="searchQuery"></StatisticsSearchForm>
      </template>
      <div slot="listContent">

        <div class="page-operation">
          <el-button size="small" class="filter-item" @click="handleExplain">字段说明</el-button>
          <el-button size="small" class="filter-item" @click="handleExport">导出</el-button>
        </div>
        
        <!-- 列表 -->
         <div class="page-list">
          <CustomerStatisticsList :list="tableList" :loading="listLoading">
          </CustomerStatisticsList>
         </div>
         <!-- 分页 -->
        <div class="page-pagination">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            :total="total"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageParams.pageCount"
            :current-page="pageParams.page"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </QueryContainer>
    <el-dialog
      :visible.sync="showExplainDialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"      
      :before-close="() => { showExplainDialog=false }"
      append-to-body
      width="30%"
      title="字段说明"
    >
      <div class="register-info">
        <div style="color: red">注：统计列表剔除了到店目的为【交车】的客流及对应数据;</div>
        <div>接待数量：创建客流的数量；同期环比：当前时间比上环比时间；</div>
        <div>平均接待时长：总接待时长/接待数量；</div>
        <div>客户数量：创建客流中以手机号去重；</div>
        <div>接待留资率：留资客户/客流总数；</div>
        <div>二次到店率：再回客户/客流总数；</div>
        <div>试驾率：试驾客户/客流总数(以智驾系统数据为准)；</div>
        <div>客流订单数：客流所对应的订单量(只有订单没有客流则没数据)；</div>
        <div>转订率：客流订单数/接待量；</div>
        <div>成交量：客流所对应订单中状态为已交车的数量；</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" @click="showExplainDialog=false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import StatisticsSearchForm from './components/StatisticsSearchForm.vue';
import CustomerStatisticsList from './components/CustomerStatisticsList.vue';
import { mapActions, mapGetters } from 'vuex';

const searchInit = {
  timeRangeArr: [],// 日期范围
  rateTimeRangeArr: [],// 环比日期范围
  intentionSeries: '', // 意向车系
  customerSource: '', // 客户来源
}

export default {
  components: {
    CustomerStatisticsList,
    StatisticsSearchForm
  },
  data() {
    return {
      searchQuery: {
        ...searchInit,
      },
      pageParams: {
        page: 1,
        pageCount: 10,
      },
      total: 0,
      searchLoading: false,
      listLoading: false,
      showExplainDialog: false,
      profile: {}, // 门店信息
      tableList: [],
      seriesList: [],
    }
  },
  created() {
    this.profile = this.$common.getDealer();
    this.initDate()
    this.getList()
    this.getSeriesList()
  },
  mounted() {
    this.getDealerRegion({ dealerId: this.profile.dealerId })
  },
  computed: {
    ...mapGetters('user',{
      storeProfile: 'profile'
    }),
    baseInfo() {
      return this.$common.getBaseInfo()
    },
  },
  methods: {
    ...mapActions('user', ['getDealerRegion']),
    // 初始化日期
    initDate() {
      const firstMonthDay = this.$moment().startOf('month').format('YYYY-MM-DD');
      const todayDate = this.$moment().format('YYYY-MM-DD');
      this.searchQuery.timeRangeArr = [firstMonthDay, todayDate];
      const momentDate1 = this.$moment(firstMonthDay, 'YYYY-MM-DD');
      const momentDate2 = this.$moment(todayDate, 'YYYY-MM-DD');
      // 计算两个日期之间相差的天数
      const diffDays = momentDate2.diff(momentDate1, 'days');
      const firstMonthDayRate = momentDate1.subtract(diffDays + 1, 'days').format('YYYY-MM-DD');
      const todayDateRate = momentDate2.subtract(diffDays + 1, 'days').format('YYYY-MM-DD');
      this.searchQuery.rateTimeRangeArr = [firstMonthDayRate, todayDateRate];
    },
    // 获取意向车系
    getSeriesList() {
      this.$httpAuth
        .post("/v1/dealerRpc/seriesList", {
          dealerId: this.profile.dealerId
        })
        .then(res => {
          this.seriesList = res.data.records;
        });
    },
    handleSizeChange(val) {
      this.pageParams.page = 1
      this.pageParams.pageCount = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageParams.page = val;
      this.getList();
    },
    handleSearch() {
      this.listLoading = true
      this.pageParams.page = 1
      this.pageParams.pageCount = 10
      this.getList()
    },
    getParams() {
      const params = { ...this.searchQuery }
      params.timeRange = {
        start: this.searchQuery.timeRangeArr?.[0] ?? '',
        end: this.searchQuery.timeRangeArr?.[1] ?? '',
      }
      delete params.timeRangeArr
      params.rateTimeRange = {
        start: this.searchQuery.rateTimeRangeArr?.[0] ?? '',
        end: this.searchQuery.rateTimeRangeArr?.[1] ?? '',
      }
      delete params.rateTimeRangeArr
      params.customerSource = params.customerSource ? String(params.customerSource): ''
      params.intentionSeries = params.intentionSeries ? String(params.intentionSeries): ''
      return params
    },
    getList() {
      const params = this.getParams()
      params.isExport = false
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$httpAuth.post("/v2/appCustomerFlowService/flowStatistics", { 
        ...params,
        dealerId: this.profile.dealerId,
        pageCount: this.pageParams.pageCount,
        pageStart: (this.pageParams.page - 1) * this.pageParams.pageCount
     }).then(e => {
        const { data=[], total=0, totalSum } = e?.data ?? {}
        this.total = total
        if (totalSum) {
          this.tableList = [...data, totalSum]
        } else {
          this.tableList = [...data]
        }
      }).finally(() => {
        this.searchLoading = false
        this.listLoading = false
        loading.close()
      })
    },
    handleExport() {
      const params = this.getParams()
      params.isExport = true
      const loading = this.$loading({
        lock: true,
        text: '正在导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$httpAuth.post("/v2/appCustomerFlowService/flowStatistics", { 
        ...params,
        dealerId: this.profile.dealerId,
      }).then(e => {
          const { url, total } = e.data
          if (total > 2000) {
            this.$message({
              customClass: 'export-message',
              dangerouslyUseHTMLString: true,
              message: '<div>应安全要求，一次性最多只能导出2000条数据</div>',
              duration: 2000
            });
          }
          setTimeout(() => {
            loading.close()
            let a = document.createElement('a')
            a.href = url
            a.click()
          }, 1000)
      }).catch(() => {
          loading.close()
      })
    },
    handleReset() {
      this.listLoading = true
      this.searchQuery = {
        ...searchInit
      }
      this.initDate()
      this.getList()
    },
    handleExplain() {
      this.showExplainDialog = true
    }
  }
}
</script>

<style scoped>
.page-container {
  height: 100%;
  overflow: hidden;
}
.page-operation {
  margin-top: 10px;
}
.page-operation .el-button {
  margin-right: 10px;
}

.page-list {
  padding: 10px 0;
}

.page-pagination {
  margin-top: 20px;
}
</style>